
import React from "react"

import PageContainer from "src/components/page/PageContainer"
import AssignmentsBrowser from "./AssignmentsBrowser"
import { Grid } from "@mui/material"

const MyAssignmentsPage: React.FC = () => {
  return (
    <PageContainer>
      <Grid item xs={12} sx={{ p: 8 }}>
        <AssignmentsBrowser />
      </Grid>
    </PageContainer>
  )
}

export default MyAssignmentsPage